import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { GETSetupEquipmentService } from '../setup-equipment/setup-equipment.service';
import { CustomerSelectItem, EquipmentSelectItem } from '../setup-equipment/setup-equipment.model';
import { GenericIdName } from '../setup-implement/setup-implement.model';
import { JobsiteSelectionFilter, ModelSelectionFilter, FilteredDigitalFormsVM, PerformSearchDigitalForm, DigtalFormSeachResult } from '../favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../favourite-dialog/favourite-dialog.service';
import { Router } from '@angular/router';
import { DigitalFormService } from '../digital-form-fill/digital-form.service';
import { CopyDigitaFormComponent } from '../digital-form-fill/component/copy-digital-form/copy-digital-form.component';
import { MatDialog } from '@angular/material/dialog';import { SelectEquipmentComponent } from '../digital-form-fill/component/select-equipment/select-equipment.component';
import { UserService } from '../../../../app/shared/services/user.service';
import { PreferencesService } from '../../preferences/preferences.service';

@Component({
  selector: 'app-digital-form-search-adminstartion',
  templateUrl: './digital-form-search-adminstartion.component.html',
  styleUrls: ['./digital-form-search-adminstartion.component.scss']
})
export class DigitalFormSearchAdminstartionComponent implements OnInit {

    //Job role
    isJobRoleDefault:boolean=true;
    isAdmin:boolean=false;
    isSupervisour:boolean=false;
  
    // Drop-down lists
    customerList: CustomerSelectItem[] = [];
    jobsiteList: GenericIdName[] = [];
    equipmentList: EquipmentSelectItem[] = [];
    familyList: GenericIdName[] = [];
    modelList: GenericIdName[] = [];
    formCatList: GenericIdName[] = [];
    formList: GenericIdName[] = [];
  
  
     // Search Filters
     selectedCustomer: number[] = [];
     selectedJobsite: number[] = []; 
     selectedEquipment: number[] = [];
     selectedFamily: number[] = [];
     selectedModel: number[] = [];
     selectedCategory:number[]=[];
     selectedForms:number[]=[];
  
  
     //Aviailable Forms
     AvailbleFilteredDigitalForms:FilteredDigitalFormsVM[]=[];
     FilledFilteredDigitalForms:FilteredDigitalFormsVM[]=[];
     PerformResult:DigtalFormSeachResult;
  
     identityServerUri: string;
     inProgress:boolean=false;
     inReview:boolean=false;
     inCompleted:boolean=false;
  NotCompleted: boolean = false;
  noRecords: boolean = false;
  
    constructor(
      private _appService: AppService,private _equipmentService: GETSetupEquipmentService,
      public _favouriteDialogService:FavouriteDialogService,private _user:UserService,
      public _formService:DigitalFormService,
      private _router: Router, private _dialog: MatDialog,
      private readonly _pref: PreferencesService,
    ) { }
  
    ngOnInit() {
      this._appService.setPageTitle('Search Digital Forms');
     // this._appService.setPageSubTitle('');
      this.LoadJobRoles();
     // this.submitSelection();
      this.loadCustomers();
      this._favouriteDialogService.getFamilyList();
      this.loadFormCatList();
      this._appService.getApplicationConfigValue("IdentityServerUri").subscribe(result => {
        this.identityServerUri = result;
    });
    }
   
  
    LoadJobRoles(){
      this._user.getUserJobRoles().subscribe(roles=>{
          roles.forEach(r => {
              switch (r.Name) {
                  case 'Inspectors':
                      this.isJobRoleDefault = false;
                      break;
                  case 'Interpreters':
                      this.isJobRoleDefault = false;
                      break;
                  case 'Super User':  
                      this.isJobRoleDefault = false;
                      break;
                  case 'Administrator':
                      this.isJobRoleDefault = false;
                      this.isAdmin=true;
                      break;
                      case 'Customer Admin':
                        this.isJobRoleDefault = false;
                      this.isAdmin=true;
                        break;
                  case 'Supervisor':
                      this.isJobRoleDefault = false;
                      this.isSupervisour=true;
                      break;
              }
          });
        
      })
      }
  
    loadCustomers() {
      this._equipmentService.getCustomerList().subscribe(r => {
          this.customerList = r;
          if(this.customerList.length==1){
            let onlyonecus = this.customerList[0].Id;
                  let arrycus = [];
                  arrycus.push(onlyonecus);
                  this.selectedCustomer =arrycus;
                if(this.selectedCustomer.length>0){
                  this.loadJobsitesForCustomer();
                } 
          }
      });
  }
  // Show the list of Jobsites for the selected customer.
      // Also loads the observation lists.
      loadJobsitesForCustomer() {
        if (this.selectedCustomer == null)
            return;
        this.selectedJobsite = null;
        this.jobsiteList = null;
        this.selectedEquipment = null;
        this.equipmentList = [];
        var params: JobsiteSelectionFilter = {
            Customers: this.selectedCustomer,
          }
        this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
            if (r) {
                this.jobsiteList = r;
                //console.log("Length jobsite",this.jobsiteList.length)
                if(this.jobsiteList.length==1){
                  let onlyonejob = this.jobsiteList[0].Id;
                  let arry = [];
                  arry.push(onlyonejob);
                  this.selectedJobsite =arry;
                  this.loadEquipmentForJobsite();
                }
            }
          });
    }
  
     // Show the list of equipment for the selected jobsite.
     loadEquipmentForJobsite() {
      if (this.selectedJobsite == null)
          return;
      var params: number[] = this.selectedJobsite;
      this._favouriteDialogService.GetEquipmentAvailable(params).subscribe(r => {
          if (r) {
              this.equipmentList = r;
          }
      });
  }
  
  loadModelList() {
    this.modelList = null
    var params: ModelSelectionFilter = {
      Families: this.selectedFamily,
      Makes: []
    }
    this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
      if (r) {
        this.modelList = r;
      }
    });
  
  }
  
  loadFormCatList() {
    this._favouriteDialogService.getFormCategoryList().subscribe(result => {
      this.formCatList = result
    })
  }
  
  LoadForms(){
    this._favouriteDialogService.GetFormListAvailable(this.selectedCategory).subscribe(res=>{
      this.formList =res;
    })
  }
  


  
  ResetFields(){
    this.selectedCustomer =[];
    this.selectedJobsite=[];
   this.selectedEquipment=[];
     this.selectedFamily=[];
     this.selectedModel=[];
     this.selectedCategory=[];
   this.selectedForms=[];
   this.NotCompleted=false;
   this.inReview=false;
   this.inProgress=false;
   this.inCompleted=false;
   
   //this.submitSelection();
   this.AvailbleFilteredDigitalForms =null;
    this.FilledFilteredDigitalForms = null;
    this.noRecords = false;
  }
  loading:boolean=false;
  submitSelection() {
    this.noRecords = false;
    this.loading = true;
    var params: PerformSearchDigitalForm = {
      customer: this.selectedCustomer,
      jobsite: this.selectedJobsite,
      equipment: this.selectedEquipment,
      family: this.selectedFamily,
      models: this.selectedModel,
      formCategory: this.selectedCategory,
      forms: this.selectedForms,
      Completed: this.inCompleted,
      InProgress: this.inProgress,
      InReview: this.inReview,
      NotCompleted: this.NotCompleted,
      AttentionRequired: false,
      ImmediateAction: false,
      MultipleAnswers: false,
      CommentAdded: false,
      AllFlags: false,
      inspector: [],
      startDate: null,
      endDate: null,
      sortName: null,
      sortOrder: null,
      PageNo: null,
      PageSize: null
    }

    this._favouriteDialogService.GetDigitalAvailableFormSearchResultAdmin(params).subscribe(res => {
      this.PerformResult = res;

      //console.log("result", this.PerformResult)
      this.AvailbleFilteredDigitalForms = this.PerformResult.AvaibleFormsList;
      if (this.PerformResult.AvaibleFormsList.length > 0)
        this.noRecords = false;
      else
        this.noRecords = true;
      //this.FilledFilteredDigitalForms = this.PerformResult.CompletedForms;
      //console.log(this.AvailbleFilteredDigitalForms)
      this.loading = false;
    })
  }
  
  redirectToEdit(formId:number){
    // this._router.navigate([this.identityServerUri+'administration/edit-digitalForm']);
   // window.open(this.identityServerUri + 'administration/edit-digitalForm?form='+formId); 
    window.open('edit-digitalform/'+ formId,'_blank');  
    //= this.identityServerUri + 'administration/edit-digitalForm?form='+formId;
  }
  uploadId:number;
  FillNewForm(formId:number){
    let selectedform = this.AvailbleFilteredDigitalForms.find(x=>x.FormId ==formId);
  
    console.log("selectedform",selectedform)
    if(selectedform.ModelsList!="" && selectedform.ModelsList!=null){
        //this need to lnked to equipment
  
  this.OpenSelectLinkedEquipmentFormDialog(formId,selectedform.LinkedModels,selectedform.LinkedCustomer);
  
    }else{
        // this not linked to equipment
        this._favouriteDialogService.CreateUploadForm(formId,0,"", "").subscribe(res=>{
          console.log("res", res)
          this.uploadId=res;
          if(res>0){
            //  this._router.navigate(['/digitalform/fill', formId, this.uploadId]);
            this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
              if(res=="True"){
                this._router.navigate(['/digitalform/fill', formId, this.uploadId]);
              }else{             
                window.open('digitalform/fill/'+ formId+ '/'+ formId,'_blank');    
              }
          });
          }
        })
    }
  }
  
  
  OpenCopyFormDialog(formId:number){
    const addSectionDialog = this._dialog.open(CopyDigitaFormComponent, {
      
      data: {
        formId: formId,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==false) {
        //this.GetDigitalFormDetails();
      }
    });
  }
  
  OpenSelectLinkedEquipmentFormDialog(formId:number,selectedModels:GenericIdName[], selectedCustomers:GenericIdName[] ){
    const addSectionDialog = this._dialog.open(SelectEquipmentComponent, {
      
      data: {
        formId: formId,
        linkedModels:selectedModels,
        linkedCustomers:selectedCustomers,
      }
    });
    addSectionDialog.afterClosed().subscribe(details => {
      if (details ==false) {
        //this.GetDigitalFormDetails();
      }
    });
  }
  
  EditFiledForm(formId:number, uploadId:number){
   // this._router.navigate(['/digitalform/fill', formId, uploadId]);
   this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/digitalform/fill', formId, uploadId]);
    }else{             
      window.open('digitalform/fill/'+ formId+ '/'+ uploadId,'_blank');    
    }
});

  }
  
  CreateNewForm(){
    //this._router.navigate([this.identityServerUri +'/administration/setup-digitalForm']);
    window.open('setup-digitalform');  
    //window.open(this.identityServerUri + 'administration/setup-digitalForm'); 
  }

}
